import { GraphSchema } from '@camelot/server';
import { User } from '@camelot/user';

import { CalendarEntry } from './calendar-entry';
import { CalendarUnavailability } from './unavailability';

export interface CalendarTimeEntry extends CalendarEntry {
  id: string;
  userId: string;
  missionId?: string;
  visitId?: string;
  unavailabilityId?: string;
  validated: boolean;
}

export interface CalendarTimeEntryExtended extends CalendarTimeEntry {
  user?: User;
  unavailability?: CalendarUnavailability;
}

export interface CalendarTimeEntryCreationPayloadInput {
  start: Date;
  end: Date;
  isAllDay: boolean;
  title?: string;
  userId: string;
  missionId?: string;
  visitId?: string;
  unavailabilityId?: string;
  validated: boolean;
}

export interface CalendarTimeEntryModifierPayloadInput {
  id: string;
  start?: Date;
  end?: Date;
  isAllDay?: boolean;
  title?: string;
  userId?: string;
  missionId?: string;
  visitId?: string;
  unavailabilityId?: string;
  validated?: boolean;

  updatedFields: string[];
}

export const calendarTimeEntryProps = new GraphSchema<CalendarTimeEntry>([
  'id',
  'start',
  'end',
  'isAllDay',
  'title',
  'userId',
  'missionId',
  'visitId',
  'unavailabilityId',
  'validated',
]);
